import React, { FC, useEffect, useState } from 'react'
import { Box, Button, DialogProps, Grid, Typography } from '@mui/material'
import { useForm } from 'react-hook-form'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import FormInput from 'components/FormInput'
import { FormInputSelect } from 'components/FormInputSelect'
import { zodResolver } from '@hookform/resolvers/zod'
import InputDatePicker from 'components/FormInputDatePicker'
import {
  TeenagerProcessHearingType,
  TeenangerProcessHearingDefaultValues,
  TeenangerProcessHearingSchema,
} from 'types/teenager-process-hearing.type'

type ModalSaveHistoryPendingProcessHearingProps = {
  open: boolean
  onClose: (indexAdolescente?: number, value?: TeenagerProcessHearingType) => void
  adolescenteToChange?: TeenagerProcessHearingType
  indexAdolescente?: number
}

const ModalSaveHistoryPendingProcessHearing: FC<ModalSaveHistoryPendingProcessHearingProps> = ({
  open,
  onClose,
  adolescenteToChange,
  indexAdolescente,
}) => {
  const [fullWidth] = useState(true)
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm')
  const {
    watch,
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm<TeenagerProcessHearingType>({
    resolver: zodResolver(TeenangerProcessHearingSchema),
    defaultValues: TeenangerProcessHearingDefaultValues,
  })

  const [showJustificativa, setShowJustificativa] = useState<boolean>(false)
  const [showMotivo, setShowMotivo] = useState<boolean>(false)
  const [showDataAgendamento, setShowDataAgendamento] = useState<boolean>(false)

  const handleClose = () => {
    onClose()
    reset()
  }

  const handleSubmitForm = (value?: TeenagerProcessHearingType) => {
    onClose(indexAdolescente, value)
    reset()
  }

  const watchMotivo = watch('motivo')
  const watchStatus = watch('status')

  useEffect(() => {
    if (watchMotivo === 'OUTROS') {
      setValue('justificativa', '')
      setShowJustificativa(true)
    } else {
      setValue('justificativa', null)
      setShowJustificativa(false)
    }
  }, [watchMotivo])

  useEffect(() => {
    if (adolescenteToChange) {
      setValue('id', adolescenteToChange.id)
      setValue('nomeAdolescente', adolescenteToChange.nomeAdolescente)
      setValue('status', '')
      setValue('dataAgendamento', null)
      setValue('motivo', null)
      setValue('indicadorIntegracao', adolescenteToChange.indicadorIntegracao)
      setValue('justificativa', null)
      setValue('oitiva', adolescenteToChange.oitiva)
    }
  }, [adolescenteToChange])

  useEffect(() => {
    console.log('errorsDialog', errors)
  }, [errors])

  useEffect(() => {
    switch (watchStatus) {
      case 'AGENDADO':
        setValue('motivo', null)
        setShowDataAgendamento(true)
        setShowMotivo(false)
        setShowJustificativa(false)
        break
      case 'NAO_REALIZADO':
        setValue('motivo', null)
        setShowDataAgendamento(false)
        setShowMotivo(true)
        setShowJustificativa(false)
        break
      default:
        setShowDataAgendamento(false)
        setShowMotivo(false)
        setShowJustificativa(false)
        setValue('motivo', null)
        break
    }
  }, [watchStatus])

  return (
    <Dialog onClose={handleClose} open={open} fullWidth={fullWidth} maxWidth={maxWidth}>
      <DialogTitle>
        <Typography variant={'h6'} color={'primary.main'}>
          INFORMAR STATUS DA OITIVA
        </Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(handleSubmitForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} />
            <Grid item xs={12}>
              <FormInputSelect
                label={'Status *'}
                name={'status'}
                control={control}
                options={[
                  //{ value: 'PENDENTE', label: 'Pendente' },
                  { value: 'NAO_REALIZADO', label: 'Não Realizado' },
                  { value: 'AGENDADO', label: 'Agendado' },
                ]}
              />
            </Grid>
            {showDataAgendamento && (
              <Grid item xs={12}>
                <InputDatePicker
                  control={control}
                  name='dataAgendamento'
                  label='Data de Agendamento *'
                  enableFuture
                />
              </Grid>
            )}
            {showMotivo && (
              <Grid item xs={12}>
                <FormInputSelect
                  label={'Motivo *'}
                  name={'motivo'}
                  control={control}
                  options={[
                    { value: 'HOSPITALIZADO', label: 'Adolescente hospitalizado' },
                    { value: 'NAO_ENCONTRADO', label: 'Adolescente não encontrado' },
                    { value: 'OUTROS', label: 'Outro' },
                  ]}
                />
              </Grid>
            )}
            {showJustificativa && (
              <Grid item xs={12}>
                <FormInput
                  label={'Justificativa'}
                  name={'justificativa'}
                  control={control}
                  multiline
                  minRows={4}
                  maxLength={250}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}
              >
                <Box sx={{ marginRight: '1rem' }}>
                  <Button variant='contained' color={'secondary'} onClick={handleClose}>
                    Cancelar
                  </Button>
                </Box>
                <Box>
                  <Button
                    variant='contained'
                    color={'secondary'}
                    onClick={async () => {
                      await handleSubmit(handleSubmitForm)()
                    }}
                  >
                    Salvar
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default ModalSaveHistoryPendingProcessHearing
